import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Translation } from '@/hoslog-intl';

export const Route = createFileRoute('/(app)/points-management/points-balance-statement')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <Translation id="pointManagement.sidebar.menu.pointsBalanceStatement" />,
      title: <Translation id="pointManagement.sidebar.menu.pointsBalanceStatement" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
